export const AXIOS_INITIALIZED = 'AXIOS_INITIALIZED';
export const initializeAxios = () => ({ type: AXIOS_INITIALIZED });

